export default "__VITE_PUBLIC_ASSET__fd698bd4__"